import React, { Component } from 'react';
import {Route, Redirect} from 'react-router-dom';
import { runInThisContext } from 'vm';
import MainUnauths from './MainUnauths'
import { connect } from 'react-redux';
import { logOutAction , onCheckout} from './../redux/modules/users'
import { PulseLoader } from 'halogenium'

class unAuthRoutes extends Component {
  
    componentDidUpdate(){
        if(this.props.path == '/reset/:resetId' && this.props.authed){
           
            let {pathname} = this.props.location
            this.props.onCheckout(pathname)
            this.props.onLogout()
            this.setState({condition:true})
        }
    }
    render(){
        let pathname = this.props.location.state !== undefined ? (this.props.location.state.from.pathname ? this.props.location.state.from.pathname : '/') : '/'
        let {authed, fetching} = this.props
        var color = '#4DAF7C';
        var style = {
            marginTop : '22%',
            marginLeft : '42%'
        };
        if(fetching){
            return(
                <div style={style}>
                <PulseLoader color={color} size="40px" margin="20px"/>
                </div>
            )
        }else{
            return( 
                <Route render={ (props)=>{ 
                   return !authed ?  (
                        <MainUnauths {...this.props} />
                        ) : (
                        localStorage.getItem('token') && <Redirect 
                        to={ pathname } />
                ) } }  />
            )
        }
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
      onLogout : () => {dispatch(logOutAction())} ,
      onCheckout : (pathname) => {dispatch(onCheckout(pathname))}
    }
  }
  
  const mapStateToProps = (state) =>{
    return {
      state : () => state
    }
  }
  
  export default connect(mapStateToProps,mapDispatchToProps)(unAuthRoutes)



// WEBPACK FOOTER //
// ./src/config/unAuthRoutes.js